import { Component, Input, AfterContentInit, ChangeDetectorRef, OnInit, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AppUser } from '../../../@core/models/app.user';
import { LoginService } from '../../../@core/data/login.service';

import { Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { generalSettings } from '../../../../main/settings';
import { FirebaseHelper } from '../../../@core/services/firebase.helper';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'edm-paywall',
  templateUrl: './paywall.component.html',
  styleUrls: ['./paywall.component.scss'],
  standalone: false
})

export class PaywallComponent implements OnInit, AfterContentInit, OnDestroy {

  @Input() model: string;
  @Input() closeWhenUrlChanges: boolean = false;
  @Input() contentId: string | null = null;
  @Input() contentType: 'product' | 'lesson' | null = null;

  iframeSrc: SafeResourceUrl;
  loadedSrc: string;

  constructor(
    private activeModal: NgbActiveModal,
    private loginService: LoginService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private firebaseHelper: FirebaseHelper,
    private deviceService: DeviceDetectorService,
  ) { }

  ngOnInit(): void {
    this.firebaseHelper.logEvent("screen_view", { screen_name: "paywall" });
    const purchaseParams: Record<string, string> = {
      os: this.deviceService.getDeviceInfo().os,
      origin: 'web',
    };
    if (this.contentType === 'product') purchaseParams['product_id'] = this.contentId;
    if (this.contentType === 'lesson') purchaseParams['lesson_id'] = this.contentId;
    this.firebaseHelper.logEvent("click_purchase_intent", purchaseParams);
    window.addEventListener('message', (event)=> {
      if (event.data == 'close') {
        this.closeModal('reload');
      }
    });
    if (this.loginService.isAuthenticated()) {
      this.loginService.loggedUser$
      .subscribe(
        (user: AppUser): void => {
          if (this.exists(user)) {
            this.loginService.dispatchEvent('paywall-pwa', user);
          }
        }
      );
    }
  }

  ngOnDestroy(): void {
    window.removeEventListener('message', ()=>{});
  }

  ngAfterContentInit(): void {
    if (this.model === null || this.model === undefined) {
      this.connectionError();
    } else {
      const height: number = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      const heightPX: string = Math.floor((height * 0.9)) + 'px';
      const absoluteContentCollection: HTMLCollection = document.getElementsByClassName('absolute-content');
      if (this.exists(absoluteContentCollection)) {
        const absoluteContent: HTMLDivElement = absoluteContentCollection[0] as HTMLDivElement;
        if (this.exists(absoluteContent)) {
          absoluteContent.style.height = heightPX;
          const modalBodyCollection: HTMLCollection = absoluteContent.getElementsByClassName('modal-body');
          if (this.exists(modalBodyCollection)) {
            const modalBody: HTMLDivElement = modalBodyCollection[0] as HTMLDivElement;
            if (this.exists(modalBody)) {
              modalBody.style.height = heightPX;
              const iframeCollection: HTMLCollection = modalBody.getElementsByTagName('iframe');
              if (this.exists(iframeCollection)) {
                const iframe: HTMLIFrameElement = iframeCollection[0] as HTMLIFrameElement;
                if (this.exists(iframe)) {
                  iframe.style.height = heightPX;
                }
              }
            }
          }
        }
      }
    }
    this.iframeSrc = this.safeUrl(this.model);
    this.cdr.detectChanges();
  }

  private connectionError(): void {
    this.router.navigate(['produtos']);
  }

  exists(object: any): boolean {
    return object !== null && object !== undefined && typeof object != 'undefined';
  }

  private safeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  checkToClose(): void {
    const iframeTags: HTMLCollection = document.getElementsByTagName('iframe');
    if (this.exists(iframeTags)) {
      const iframe: HTMLIFrameElement = iframeTags[0] as HTMLIFrameElement;
      if (iframe.getAttribute('src') !== null) {
        if (this.exists(this.loadedSrc) && this.closeWhenUrlChanges) {
          this.closeModal();
        } else {
          this.loadedSrc = iframe.getAttribute('src');
        }
      }
    }
  }

  iconCustomLayoutClass(): string {
    return generalSettings.timelineIconsLayout + '-icon';
  }

  iconTypeLayoutClass(): string {
    return generalSettings.iconsType + '-icons-type';
  }

  closeModal(data: string = null): void {
    this.activeModal.close(data);
  }
}
